import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersChildrenParticipatingInGroupActivity = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children participating in group activity (%)" />
    </Box>
  );
};
